import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Settings} from '@common/core/config/settings.service';
import {Translations} from '@common/core/translations/translations.service';
import {ThemeService} from '@common/core/theme.service';
import {ValueLists} from '@common/core/services/value-lists.service';
import {BehaviorSubject} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {Localizations} from '@common/core/translations/localizations.service';
import {Localization} from '@common/core/types/models/Localization';
import { Router } from '@angular/router';
import { CurrentUser } from '@common/auth/current-user';
import { MenuItemCondition } from '@common/core/ui/custom-menu/menu-item';
import { MatDialog } from '@angular/material/dialog';
import { SubscribeNewsletterComponent } from 'src/app/subscribe-newsletter/subscribe-newsletter.component';
import { UnsubscribeNewsletterComponent } from 'src/app/unsubscribe-newsletter/unsubscribe-newsletter.component';

@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFooterComponent {
    copyrightText: string;
    localizations$ = new BehaviorSubject<Localization[]>([
        {id: 1, name: 'English', language: 'en'},
    ]);
    changingLang$ = new BehaviorSubject<boolean>(false);
    constructor(
        public settings: Settings,
        public i18n: Translations,
        public theme: ThemeService,
        private valueLists: ValueLists,
        private localizations: Localizations,
        private router: Router,
        public currentUser: CurrentUser,
        public dialog: MatDialog
    ) {
        const year = new Date().getFullYear();
        this.copyrightText = this.i18n.t(
            'Copyright © :year, All Rights Reserved by JioSh URL Private Limited.',
            {year}
        );
    }

    langMenuOpened() {
        this.valueLists.get(['localizations']).subscribe(response => {
            this.localizations$.next(response.localizations);
        });
    }

    policy() {
        this.router.navigate(['/pages/03ab9738-2e96-4f39-9e6b-3f9039d89716/privacy-policy']);
    }
    tnc(){
        this.router.navigate(['pages/9f2257cb-cb2a-47e6-a599-5df038d2c163/terms-of-service']);
    }
    aboutUs(){
        this.router.navigate(['pages/3ab4e58f-e8ef-4721-9194-7220689c5b27/about-us']);
    }
    terms(){
        this.router.navigate(['pages/547e6be9-7161-42b4-b3ce-db1c73dbb2ab/terms']);
    }
    refund(){
        this.router.navigate(['pages/3edcf0f4-92e3-4aa0-be7e-fbdac59fb72e/refund-policy']);
    }
    compliance(){
        this.router.navigate(['pages/cc843653-01f5-426a-b8a6-c522d89c666f/compliance']);
    }
    cookiePolicy(){
        this.router.navigate(['pages/f961dc66-4c7e-4a51-8098-c642c472f470/cookie-policy']);
    }
    support(){
        this.router.navigate(['contact-us']);
    }
    helpLogin(){
        this.router.navigate(['help/how-to-login']);
    }
    helpRegister(){
        this.router.navigate(['help/how-to-register']);
    }

    url(){
        this.router.navigate([]).then(result => {  window.open('jiosh-url-button', '_blank'); });
    }
    api(){
        this.router.navigate([]).then(result => {  window.open('https://jio.sh/api-docs', '_blank'); });
    }
    subscribe(){
        const dialogRef = this.dialog.open(SubscribeNewsletterComponent, {
          });
          dialogRef.afterClosed().subscribe(result => {
          });
    }
    unsubscribe(){
        const dialogRef = this.dialog.open(UnsubscribeNewsletterComponent, {
        });
        dialogRef.afterClosed().subscribe(result => {
        });
    }

    changeLanguage(loc: Localization) {
        if (this.i18n.isActive(loc)) {
            return;
        }
        this.changingLang$.next(true);
        this.localizations
            .get(loc.name)
            .pipe(finalize(() => this.changingLang$.next(false)))
            .subscribe(response => {
                this.i18n.setLocalization(response.localization);
            });
    }

    public shouldShow(condition: MenuItemCondition): boolean {
        if (!condition) return true;

        if (Array.isArray(condition)) {
            return condition.every(c => this.shouldShow(c));
        }

        if (typeof condition === 'function') {
            return condition(this.currentUser, this.settings);
        }

        switch (condition) {
            case 'auth':
                return this.currentUser.isLoggedIn();
            case 'guest':
                return !this.currentUser.isLoggedIn();
            case 'admin':
                return this.currentUser.hasPermission('admin');
            default:
                let negate = false;
                if (condition.startsWith('!')) {
                    condition = condition.substr(1);
                    negate = true;
                }
                if (condition.startsWith('permission:')) {
                    return (
                        negate !==
                        this.currentUser.hasPermission(condition.split(':')[1])
                    );
                } else {
                    return true;
                }
        }
    }

}
